<template>
  <div ref="container">
    <a-modal :title="title" :width="500" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:60%;">
      <!-- <a-card>
        <div ref="hiprintContainer"></div>
      </a-card> -->
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :lg="24" :md="24" :sm="24" >
            <a-list>
              <div class="module-info">
                <p>模版名称：</p>
                <span>{{ printModule.templateName }}</span>
              </div>
              <div class="module-info">
                <p>尺寸：</p>
                <span>{{ printModule.size }}</span>
              </div>
              <div class="module-info">
                <p>备注：</p>
                <span>{{ printModule.remark }}</span>
              </div>
            </a-list>
          </a-col>
          <a-col :lg="24" :md="24" :sm="24" style="margin-bottom: 20px" v-if="printType != 'Singleprinting'">
            <a-radio-group v-model="isAllSelect" @change="onChange">
              <a-radio value="1" >全部打印</a-radio>
              <a-radio value="0" >部分打印</a-radio>
              <a-radio value="2" v-if="isShowNoComplete">打印未打印部分</a-radio>
            </a-radio-group>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24" v-if="isShow">
            <a-form-item label="起始序号：" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin:0">
              <a-input placeholder="请输入起始序号" v-model="startLocation"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24"  v-if="isShow">
            <a-form-item label="结束序号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin:0">
              <a-input placeholder="请输入结束序号" v-model="endLocation"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item label="打印份数" :labelCol="{span: 4}" :wrapperCol="{span: 20}" style="margin-bottom: 0;">
              <a-input-number placeholder="1" v-model="copies" :min="1"></a-input-number>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { printApi, printgetAll, piInfoApi, getPublicTemplateDatas } from '@/api/api';
import TaskRunner from 'concurrent-tasks';
import { startPrint } from '@/views/UDIadmin/modules/allPrint';
import QRCode from 'qrcode';
// import Hiprint from 'vue-plugin-hiprint';
import Hiprint from 'vue-plugin-hiprint';
console.log('Hiprint:', Hiprint); // 输出引入的 Hiprint 对象
console.log('typeof Hiprint:', typeof Hiprint); // 输出 Hiprint 的类型


export default {
  name: 'VendorModal',
  data() {
    return {
      printType: '',
      item: {},
      total: 1,
      title: '选择打印模版',
      visible: false,
      model: {},
      noPrintNum: 0,
      printModule: {},
      dataSource: [],
      labelCol: {
        span: 10,
      },
      wrapperCol: {
        span: 13,
        offset: 1,
      },
      loading: false,
      productInfo: {},
      templateList: [],
      templateid: '',
      startLocation: '',
      endLocation: '',
      copies: 1,
      isAllSelect: '1',
      isShow: false,
      isShowNoComplete: false,
      form: this.$form.createForm(this),
      validatorRules: {
        templateid: {
          rules: [
            {
              required: true,
              message: '请选择模版名称!',
            },
          ],
        },
        startLocation: {
          rules: [
            {
              required: true,
              message: '请选择输入起始序号!',
            },
          ],
        },
        endLocation: {
          rules: [
            {
              required: true,
              message: '请选择输入结束序号!',
            },
          ],
        },
      },
      productList: [],
      hiprint: null,
    };
  },
  created() {},
  methods: {
    // 切换打印方法
    onChange(value) {
      this.noPrintNum = value.target.value;
      this.isAllSelect = value.target.value;
      if (this.isAllSelect === '0') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    // 直接传入列表
    async add(e) {
      this.visible = true;
      this.form.resetFields();
      this.getlist();
      if (e) {
        // this.productList = e
      }
    },
    // 通过id获取列表
    async addStr(e, type, info) {
      this.printType = type;
      this.visible = true;
      this.form.resetFields();
      this.productList = [];
      this.getlist();
      this.getPublicTemplateData(info);
      this.item = e;
      this.isShowNoComplete = e.notPrintCount!== 0;
      if (e && type === 'Batchprint') {
        const res = await piInfoApi({ id: e.id, limit: 1, startNumber: -1, endNumber: -1 });
        if (res.errno === 200 && res.errmsg === '成功') {
          if (res.data.list.length === 0) {
            this.$message.error('未查询到相关数据！');
          } else {
            this.loading = false;
            this.productList = res.data.list;
            this.total = res.data.total;
          }
        } else {
          this.$message.error(res.data || res.errmsg);
        }
      } else if (e && type === 'Singleprinting') {
        this.productList.push(e);
        this.total = 1;
      }
    },
    // 获取打印模版信息
    async getPublicTemplateData(info) {
      const params = {
        templateId: info,
      };
      const res = await getPublicTemplateDatas(params);
      if (res.code === 200) {
        this.printModule = res.data;
        this.printModule.size = res.data.paperWidth + '*' + res.data.paperHeight;
        await this.initHiprint();
      }
    },
    // 初始化 hiprint
    async initHiprint() {
      const templateHtml = await this.generateTemplateHtml();
      console.log(templateHtml,'this.templateHtml=====================')
      this.hiprint = new Hiprint({
        el: this.$refs.hiprintContainer,
        template: {
          content: templateHtml,
        },
      });
      console.log(this.hiprint,'this.hiprint=====================')
    },
    // 生成打印模板 HTML
    async generateTemplateHtml() {
      let templateHtml = '';
      const datas = this.printModule.datas || [];
      for (const data of datas) {
        const option = JSON.parse(data.option);
        const { options, printElementType } = option;
        if (printElementType.type === 'qrcode') {
          const qrData = options.testData;
          if (qrData) {
            try {
              const qrUrl = await QRCode.toDataURL(qrData, {
                width: options.width,
                height: options.height,
              });
              
              templateHtml += `<img src="${qrUrl}" style="position: absolute; left: ${options.left}px; top: ${options.top}px; width: ${options.width}px; height: ${options.height}px;">`;
              const div = document.createElement('div');
              div.innerHTML = templateHtml;
              div.style.display = 'none';
              document.body.appendChild(div);

              console.log(templateHtml,'templateHtml====================')
            } catch (error) {
              console.error('二维码生成失败:', error);
              this.$message.error(`二维码[${data.elementName || '未知'}]生成失败`);
            }
          } else {
            console.error('缺少二维码数据');
            this.$message.error(`二维码[${data.elementName || '未知'}]缺少数据`);
          }
        } else if (printElementType.type === 'text') {
          templateHtml += `<div style="position: absolute; left: ${options.left}px; top: ${options.top}px; font-size: ${options.fontSize || 12}px; font-family: ${options.fontFamily || 'Arial'}; color: ${options.color || '#000000'};">${options.title}</div>`;
        }
      }
      return templateHtml;
    },
    async getlist() {
      const res = await printgetAll();
      if (res.code === 200) {
        this.templateList = res.data;
      } else {
        this.$message.error(res.data || res.msg);
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const productDi = this.templateList.find((x) => x.uuid === values.templateid);
          const printCopies = this.copies;
          if (this.printType === 'Singleprinting') {
            startPrint(this.productList, this.printModule, this.copies, (detailIdArr) => {
              console.log('打印完成===============', detailIdArr);
              this.$emit('updateTableData', detailIdArr);
            });
            this.handleCancel();
            return false;
          }
          const runner = new TaskRunner();
          runner.setConcurrency(1);
          const task = [];
          const limit = 500;
          const pageNumber = Math.ceil(this.total / limit);
          let beginNumber = 0;
          let endNumber = this.total;
          if (this.isAllSelect === '0' && this.startLocation && this.endLocation) {
            if (!/^[1-9]\d*$/.test(this.startLocation) ||!/^[1-9]\d*$/.test(this.endLocation)) {
              this.$message.warning('请输入正整数');
              return false;
            }
            if (!(parseInt(this.startLocation) <= parseInt(this.endLocation))) {
              this.$message.warning('开始不能小于结束');
              return false;
            }
            beginNumber = parseInt(this.startLocation) - 1;
            endNumber = parseInt(this.endLocation);
          }
          if (this.noPrintNum === 2) {
            for (let i = 1; i <= pageNumber; i++) {
              task.push(async (doneApi) => {
                const res = await piInfoApi({ id: this.item.id, printNum: 0, page: i, limit, startNumber: -1, endNumber: -1 });
                if (res.errno === 200 && res.errmsg === '成功') {
                  if (res.data.list.length === 0) {
                    this.$message.error('未查询到相关数据！');
                    doneApi();
                  } else {
                    const options = { pageNumber: i, limit };
                    this.productList = res.data.list;
                    startPrint(this.productList, this.printModule, this.copies, doneApi, runner, options, (detailIdArr) => {
                      console.log('打印完成===============', detailIdArr);
                      this.$emit('updateData', detailIdArr);
                    });
                  }
                } else {
                  this.$message.error(res.data || res.errmsg);
                }
              });
            }
            runner.addMultiple(task);
            this.handleCancel();
          } else {
            for (let i = 1; i <= pageNumber; i++) {
              task.push(async (doneApi) => {
                const res = await piInfoApi({ id: this.item.id, page: i, limit, beginNumber, endNumber });
                if (res.errno === 200 && res.errmsg === '成功') {
                  if (res.data.list.length === 0) {
                    doneApi();
                  } else {
                    const options = { pageNumber: i, limit };
                    this.productList = res.data.list;
                    startPrint(this.productList, this.printModule, this.copies, doneApi, runner, options, (detailIdArr) => {
                      console.log('打印完成===============', detailIdArr);
                      this.$emit('updateData', detailIdArr);
                    });
                  }
                } else {
                  this.$message.error(res.data || res.errmsg);
                }
              });
            }
            runner.addMultiple(task);
            this.handleCancel();
          }
        }
      });
    },
    handleCancel() {
      this.close();
    },
  },
};
</script>
<style scoped>
  .module-info {
    display: flex;
    justify-content: flex-start;
  }
</style>    